export default __webpack_public_path__ + "static/media/logoTop.3a1c3550.png";